export const clearSuccessMsg = (location) => {    
    if (location.state && location.state.successMsg) {        
        const newState = { ...location.state };
        delete newState.successMsg;
        window.history.replaceState(newState, document.title, window.location.pathname);
    }
};